import * as React from 'react'
import { SVGProps } from 'react'
const SvgArrowRigh2T = (props: SVGProps<SVGSVGElement>) => (
  <svg height={16} viewBox="0 0 16 16" width={16} {...props}>
    <path d="M8.6 3.5 12.1 7H0v2h12.1l-3.5 3.5 1.4 1.4L16 8l-6-5.9z" />
  </svg>
)
export default SvgArrowRigh2T
